import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import FeedIcon from 'modules/Common/components/png/FeedIcon';
import { Link } from 'react-router';

export default class CollapsibleSection extends Component {
  static propTypes = {
    collapsed: PropTypes.bool,
    children: PropTypes.node,
    feedLogo: PropTypes.string,
    title: PropTypes.string.isRequired,
    linkTo: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      collapsed: props.collapsed || false
    };
  }

  componentWillReceiveProps(nextProps) {
    // checks that collapsed has initially been set, and then checks whether to update
    if (this.state.hasOwnProperty('collapsed') && this.state.collapsed !== nextProps.collapsed) {
      this.setState({
        collapsed: nextProps.collapsed
      })
    }
  }

  handleClick() {
    this.setState({collapsed: !this.state.collapsed});
  }

  render() {
    require("./CollapsibleSection.scss");

    return (
      <div className="collapsibleSection">
        <div onClick={this.handleClick} className={this.state.collapsed ? "dividerRowCollapsed" : "dividerRow"}>
          <h2 className={this.props.feedLogo ? "sectionTitleWithProviderLogo" : "sectionTitle"}>
            {this.props.linkTo ? <Link to={this.props.linkTo}>{this.props.title}</Link> : this.props.title}
          </h2>
          { !!this.props.feedLogo && <FeedIcon feed={this.props.feedLogo}/>}
          <div className="collapseArrow">
            <CaretIcon type="line" direction={this.state.collapsed ? "down" : "up"}/>
          </div>
        </div>
        {
          this.state.collapsed || <div>{this.props.children}</div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/CollapsibleSection.js